<template>
<div class="container element-margin">
    <b-row class="correctPos">
      <b-col>
    <div id="vendorLink">
      <VendorSearchup  />
    </div>
  </b-col>
  </b-row>
   </div>
</template>

<script>
import VendorSearchup from '../components/vendorSearchup.vue'

export default {
  name: 'SelectVendor',
  components: {
    VendorSearchup,
  },
  data() {
    return {
      selected: 'radio1',
      options: [
        { text: '3 Months', value: 'radio1' },
        { text: '12 Months', value: 'radio2' },
        { text: '18 Months', value: 'radio3' },
      ],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      amount: '',
      paymentType: '',
      paymentTypeButton: false,
      repairOfferAmount: '',
      updatedPayment: '',
      fees: '',
      rate: '',
      term: '',
      isHidden: true,
      selectedRepair: 'Choose...',
      repairOptions: [
        'Mechanical',
        'Collision',
        'Electrical',
        'Rust',
        'Exhaust',
        'Rims And Tires',
        'Choose...',
      ],
      approvedLoan: '',
      mean: '',
    }
  },
  computed: {
    // carSpec() {
    //   return this.$store.state.userData.carDetails.substring(0, 4)
    // },
  },
  beforeMount() {
    this.mean = this.$store.state.userData.marketValue
    this.repairOfferAmount = this.$store.state.userData.loanRequested
  },
  mounted: function() {
    if (!this.$store.state.userData.payment) {
      this.$router.push({
        name: 'Home',
      })
    }
  },
  //   beforeCreate: function() {
  //   if (this.$route.query.vendor) {
  //     this.$store.state.vendor = this.$route.query.vendor || localStorage.getItem('vendor')
  //     localStorage.setItem('vendor', this.$route.query.vendor)
  //     this.$router.push({
  //       path: '/'
  //     })
  //   }
  //   document.body.className = 'home-style three'
  // },
  methods: {
    // submit() {
    //   this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
    //   this.$router.push({
    //     name: 'PaymentCustomize',
    //   })
    // },
  },
}
</script>

<style scoped>
@media (max-width: 560px) {
  .correctPos {
    padding-top: 4rem;
  }
}
/* .flow-title {
  padding-top: 2%;
}

.element-margin {
  margin-bottom: 13%;
  text-align: center;
}

.element-center {
  margin: 0 auto;
}

.container {
  margin-top: 1.5rem;
  margin-bottom: 6rem;
}

.box {
  padding: 6rem;
  border-top: 3px solid #40c991;
}

.box .separator .line {
  width: 1px;
  height: 40%;
  background-color: #a803a8;
  margin: 0 auto;
}

.box .separator .or {
  margin: 0 auto;
  width: fit-content;
  height: 20%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}

select,
input {
  margin-top: 1.5rem;
  border-radius: 1rem;
}

select:focus,
input:focus {
  box-shadow: none;
}

.input-container input {
  width: 250px;
}

.input-container select {
  width: 70px;
} */
</style>



// WEBPACK FOOTER //
// src/pages/select_vendor.vue